import { Hidden } from "@material-ui/core";
import * as React from "react";
import { Component, ReactNode } from "react";
import { Button, Grid, Header } from "semantic-ui-react";
import DeleteAuthentication from "../../application/usecase/authentication/DeleteAuthentication";
import GetAuthentication from "../../application/usecase/authentication/GetAuthentication";
import LogoutResKa from "../../application/usecase/authentication/LogoutResKa";
import Authentication from "../../domain/authentication/Authentication";
import Footer from "../components/footer/Footer";

class LogoutContainer extends Component {
  private readonly getAuthentication: GetAuthentication = new GetAuthentication();
  private readonly deleteAuthentication: DeleteAuthentication = new DeleteAuthentication();
  private readonly logoutResKa: LogoutResKa = new LogoutResKa();

  public componentDidMount(): void {
    this.logoutResKa.execute();
  }

  public render(): ReactNode {
    const authentication: Authentication = this.getAuthentication.execute();
    return (
      <>
        <Grid centered={ true } style={ {height: "100vh"} } verticalAlign="middle">
          <Grid.Column style={ {maxWidth: 450} }>
            <Header as="h1" color="grey" textAlign="center">ResKa</Header>
            <Header as="h2" color="grey" textAlign="center">ログアウトしました</Header>
            {
              authentication.autoLogin.value
                ?
                <>
                  <Hidden smDown={ true }>
                    <Grid columns={ 2 } divided={ true }>
                      <Grid.Row>
                        <Grid.Column>
                          <Button color="teal" fluid={ true } onClick={ () => window.location.href = "/" }>再ログインする</Button>
                        </Grid.Column>
                        <Grid.Column>
                          <Button fluid={ true } onClick={ () => this.deleteAutoLogin() }>自動ログインを解除する</Button>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Hidden>
                  <Hidden mdUp={ true }>
                    <Button color="teal" fluid={ true } onClick={ () => window.location.href = "/" }
                            style={ {marginBottom: "1rem"} }>再ログインする</Button>
                    <Button fluid={ true } onClick={ () => this.deleteAutoLogin() }>自動ログインを解除する</Button>
                  </Hidden>
                </>
                :
                <>
                  <Button fluid={ true } onClick={ () => window.location.href = "/" }>ログイン画面へ戻る</Button>
                </>
            }
            <Footer/>
          </Grid.Column>
        </Grid>
      </>
    );
  }

  private deleteAutoLogin() {
    this.deleteAuthentication.execute();
    window.location.href = "/";
  }
}

export default LogoutContainer;